import { put, select, takeLatest } from 'redux-saga/effects'
import { IBodySurveyState, IExamValue } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { getPcrIdSelector } from '../../../../home/selectors/getPcrId.selector'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { saveBodySurvey, setExamPNNVValue, setExamValue, setFindingsValue } from '../store/bodySurvey.actions'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* deleteSummaryExam() {
  const pcrID: string = yield select(getPcrIdSelector)
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)

  const { __deleteSummaryExams, __deleteSummaryFindings, findings, examValues, examValuesPNNVs } = bodySurvey
  if (!pcrID) return
  try {
    const filterOptions: IExamValue[] = [...examValues, ...examValuesPNNVs]
    let updatedOptions: IExamValue[] = []
    let updatedFindings
    if (Array.isArray(__deleteSummaryExams)) {
      updatedOptions = filterOptions.filter(
        (exam) =>
          !__deleteSummaryExams.some((deleteExam) =>
            deleteExam.locationId === 13 || deleteExam.locationId === 12
              ? deleteExam.customCommandFacId === exam.customCommandFacId
              : deleteExam.id === exam.id
          )
      )
    } else {
      updatedOptions = filterOptions.filter((exam) => exam.id !== __deleteSummaryExams.id)
    }
    const separateExamValues = updatedOptions.filter((option) => option.segmentId === 1)
    const separateExamPnnvValues = updatedOptions.filter((option) => option.segmentId === 2)

    if (__deleteSummaryFindings) {
      updatedFindings = findings.filter(
        (finding) => !__deleteSummaryFindings.some((option) => option?.locationId === finding?.locationId)
      )
    }
    yield put(setFindingsValue(updatedFindings))
    yield put(setExamValue(separateExamValues))
    yield put(setExamPNNVValue(separateExamPnnvValues))
    yield put(saveBodySurvey())
  } catch (e) {
    yield put(throwPcrException(`deleteSummaryExamSaga() error: ${e}`))
  }
}

export function* deleteSummaryExamSaga() {
  yield takeLatest([BodySurveyConstants.DELETE_SUMMARY_DATA], performWithMutexHOG, deleteSummaryExam)
}
